function LoadingSpinner({ message = 'Loading...', ui = {} }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 p-6">
      <div
        className="w-5 h-5 border-2 rounded-full animate-spin"
        style={{
          borderColor: ui.borderSecondary || '#e5e7eb',
          borderTopColor: ui.text || '#000',
        }}
      />
      <span className="text-xs" style={{ color: ui.textSecondary || '#6b7280' }}>
        {message}
      </span>
    </div>
  );
}

export default LoadingSpinner;
